<template>
    <div class="r-card">
        <div class="flex items-center mb-10">
            <span class="option font-medium mr-10">Option #{{ option }}</span>
            <hr class="flex-grow mt-1">
        </div>
        <div class="flex flex-col md:flex-row md:items-center space-y-5 md:space-y-0 mb-10">
            <img v-if="product.format == 'Cabinet'" class="r-card-icon mr-10" src="/img/icon-colors.png">
            <img v-else class="r-card-icon mr-10" src="/img/Icona_rack.png">
            <h3 class="product-title r-card-title sm:mr-8 self-start md:self-center">{{product.name}}</h3>
            <p class="product-quantity r-card-title">x{{ `${product.quantity} ${product.quantity === 1 ? 'unit' : 'units'}` }}</p>
        </div>
        <div class="r-card-cols">
            <div>
                <div class="r-card-description">
                    <h6 class="mb-3">{{product.subtitle[locale]}}</h6>
                    <p>{{product.description[locale]}}</p>
                </div>
                <div>
                    <h6 class="grey power">AC Power</h6>
                    <p class="mb-3">{{product.AC_power_text}}</p>
                </div>
            </div>
            <div>
                <div>
                    <h6 class="grey">DC Power</h6>
                    <p v-html="product.DC_power_text || '&mdash;'"></p>
                </div>
                <div>
                    <h6 class="grey current">AC Current (per phase)</h6>
                    <p class="mb-3" v-html="product.AC_current_text || '&mdash;'"></p>
                </div>
            </div>
            <div>
                <h6 class="grey">DC Current {{ product.name.includes('B2C') ? '(independent/parallel)' : '(per phase/parallel)' }}</h6>
                <p v-html="product.DC_current_text || '&mdash;'"></p>
            </div>
            <!-- <div class="bi-avoid">
                <h6 class="grey r-card-key-features">Key Features</h6>
                <p v-for="feature in product.features" :key="feature.id" class="mb-2 leading-tight">
                    {{ feature.name }}
                </p>
            </div> -->
        </div>
        <a v-if="product.url" :href="product.url" target="_blank" class="product-url flex ml-auto mt-10 lg:mt-4">
            <span class="font-medium">Find out more</span>
            <img src="/img/left-arrow-green.svg" class="transform rotate-180 ml-2">
        </a>
    </div>
</template>
<script>
export default {
    props:{
        product: {
            type: Object,
            required: true,
        },
        option: {
            type: Number,
            required: true,
        }
    },
    computed: {
         locale() {
            return this.$route.params.locale; 
        },
    }
}
</script>
